/**
Controller helper for rendering "action" commands as buttons, 
and running "startup" and "execute" commands
*/

import Portal = require("portal-gis");
import Mediator = require("../../mediator");
import Utils = require("../../utils");

interface View {
    addButton(command: Portal.CommandLeaf, container?: JQuery): JQuery;
}

class CommandController<T extends View> {
    button: JQuery;

    static about = `
Controller helper for rendering "action" commands as buttons, and running "startup" and "execute" commands.  Types include: 
|Type|About|
|----|-----|
|action|render as a button, execute when clicked|
|execute|immediate execution|
|startup|immediate execution|
    `;

    constructor(public controller: T, public command: Portal.CommandLeaf, public mediator: Mediator) {
        // instantiate command, run 'startup', render 'action' as button
        switch (command.type) {
            case "action":
                break;
            case "execute":
            case "startup":
                Utils.execute(command, mediator, {
                    controller: controller
                });
                break;
        }
    }

    remove() {
        if (this.button) {
            this.button[0].parentNode.removeChild(this.button[0]);
            this.button = null;
        }
    }

    render() {
        switch (this.command.type) {
            case "action":
                if (!this.button) {
                    this.button = this.controller.addButton(this.command);
                } else {
                    // update the text
                    // disable it
                    // remove it
                }
                break;
        }
    }

}

export = CommandController;